<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-12 text-center spotify-callback">
    <svg class="spotify-logo mb-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="11" fill="#1DB954"/>
      <path d="M7 14.4c3-.9 6.1-.7 8.6.8M6.7 11.2c3.6-1.1 7.4-.8 10.4 1M6.8 8c4.2-1.2 8.6-.8 12 1.2"
            stroke="#FFFFFF" stroke-width="1.6" stroke-linecap="round"/>
    </svg>
    <div class="fw-bold heading mb-2">{{ heading }}</div>
    <div class="message col-10">{{ message }}</div>
    <div v-if="isDone" class="fw-bold mt-4 col-8 return-button" @click="returnToGame">
      Back to Mzansi Rhythm
    </div>
  </div>
</template>

<script>
import SpotifyService from "@/api/services/spotifyService";

export default {
  name: "SpotifyCallbackView",
  data() {
    return {
      heading: 'Connecting to Spotify',
      message: 'Hang tight, this only takes a second.',
      isDone: false
    }
  },
  async mounted() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('error')) return this.fail('Spotify connection cancelled', 'You can try again from the game at any time.');

    try {
      await SpotifyService.exchangeCodeForToken(params.get('code'), params.get('state'));
    } catch (error) {
      console.error('Spotify token exchange failed:', error);
      return this.fail('Could not connect to Spotify', 'Please head back to the game and try again.');
    }

    const pendingTrack = SpotifyService.takePendingTrack();
    if (!pendingTrack) return this.succeed('Spotify connected', 'Head back to the game to start adding songs.');

    try {
      const result = await SpotifyService.addTrackToLikedSongs(pendingTrack);
      if (result.added) return this.succeed('Song added', `${pendingTrack.title} is now in your Spotify Liked Songs.`);
      return this.succeed('Spotify connected', `We could not find ${pendingTrack.title} on Spotify, but you are connected now.`);
    } catch (error) {
      console.error('Spotify add to liked songs failed:', error);
      return this.succeed('Spotify connected', 'We could not add that song, but you are connected now.');
    }
  },
  methods: {
    succeed(heading, message) {
      this.heading = heading;
      this.message = message;
      this.isDone = true;
    },
    fail(heading, message) {
      this.heading = heading;
      this.message = message;
      this.isDone = true;
    },
    returnToGame() {
      if (window.opener) return window.close();
      this.$router.replace({name: 'home'});
    }
  }
}
</script>

<style scoped>
.spotify-callback {
  min-height: 100svh;
  padding: 24px;
  color: #2B2B45;
}

.spotify-logo {
  width: 72px;
}

.heading {
  font-size: 20px;
}

.message {
  font-size: 14px;
  opacity: 0.75;
}

.return-button {
  padding: 12px;
  border-radius: 24px;
  background: #1DB954;
  color: #FFFFFF;
  cursor: pointer;
}
</style>
